// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-checkbox .v-label[data-v-76eb272f] {\n  color: var(--font-color) !important;\n}\n.form-checkbox .v-input--selection-controls__input[data-v-76eb272f] {\n  margin-right: 0px !important;\n}\n.other-choice .other-text[data-v-76eb272f] {\n  flex: 0 1 240px;\n  min-width: 140px;\n}", ""]);
// Exports
module.exports = exports;
